import { render, staticRenderFns } from "./Werven.vue?vue&type=template&id=706ab87c&"
import script from "./Werven.vue?vue&type=script&lang=js&"
export * from "./Werven.vue?vue&type=script&lang=js&"
import style0 from "./Werven.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports